import {
  FILTER_PARAMETER_TYPE,
  GROUP_TYPE,
  SEGMENT_SORT_BY_TYPE_ORDER,
} from '@helpers/constants';
import { isEmpty } from 'lodash';

export const convertToFilterParameterType = (
  detectionType: string
): FILTER_PARAMETER_TYPE | undefined => {
  // vehicle is combined with license plate in the filter
  if (detectionType === 'vehicle') {
    return 'licensePlate'; // as FilterListType;
  }

  // remainder of types are
  return detectionType as FILTER_PARAMETER_TYPE;
};

export function getDominantSegmentType(types: GROUP_TYPE[]) {
  if (isEmpty(types)) {
    return undefined;
  }
  const map = {} as { [key in GROUP_TYPE]: number };

  for (const type of types) {
    // don't allow udr to be dominant type
    if (type === 'udr') {
      continue;
    }

    let filterType = type;
    if (type === 'vehicle') {
      filterType = 'licensePlate';
    }

    if (!map[filterType]) {
      map[filterType] = 0;
    }
    map[filterType] += 1;
  }

  let maxCountTypes = [] as GROUP_TYPE[];
  let maxCount = 0;
  for (const type of Object.keys(map) as GROUP_TYPE[]) {
    if (map[type] > maxCount) {
      maxCountTypes = [type];
      maxCount = map[type];
    } else if (map[type] === maxCount) {
      maxCountTypes.push(type);
    }
  }
  // tie breaking
  let dominantType: GROUP_TYPE | undefined = undefined;
  for (const type of SEGMENT_SORT_BY_TYPE_ORDER) {
    if (maxCountTypes.includes(type)) {
      dominantType = type;
      break;
    }
  }

  return dominantType;
}
